import { Typography } from '@mui/material';
import React from 'react';
import SouthProp from './SP';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
// import CardTemp from './CardTemplate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMessage,
  faCircleInfo,
  faParagraph,
  faQuestion,
  faCircleQuestion,
} from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
// import { FormatLineSpacing } from '@mui/icons-material';
// import { Fonts } from 'react-bootstrap-icons';
library.add(faQuestion, faMessage, faParagraph, faCircleInfo, faCircleQuestion);

const GeneralList = [
  {
    quest:
      ' - When I return from LOA, do I resume my parking at the same parking facility that I used before my LOA began?',
    answer:
      'Yes, employees who return from LOA park at the same parking facility where they parked before going on LOA. Moreover, their parking access and restrictions will remain unchanged.',
    id: 'div1',
  },
  {
    quest: 'Is there a prorate amount that I must pay when I open an account?',
    answer:
      'Yes, a prorated amount must be paid upon opening an account. The amount due is shown on a rate breakdown sheet that the parking team must email to you. Prorate calculations differ based on whether the employee gets paid weekly or biweekly.',
    id: 'div2',
  },

  {
    quest: 'How do I pay my parking fee each month?',
    answer:
      'It is recommended that all employees participate in the NYP payroll deduction program. An employee can request that he or she be billed each month. Employees who prefer to be billed must pay their parking fee before the fifth business day of each month.',
    id: 'div3',
  },
  {
    quest: 'Can I suspend my account?',
    answer:
      'Employees who are not planning to take a leave of absence (LOA) may cancel their accounts at any time, but the cancellation will take effect on the 15th or at the end of the month. In other words, if you park for at least one day between the 1st and 15th of the month, or from the 16th until the end of the month, you will be charged for the whole period. Accounts can only be suspended for employees who are going on LOA. Parking Office personnel may request paperwork to confirm whether a LOA has been authorized.',
    id: 'div4',
  },
  {
    quest:
      'If I park at one campus, do I have access to other campuses’ parking',
    answer:
      'No. Because of waiting lists, we do not grant access to other campuses. Your access is limited to the Campus and location to which you have been assigned.',
    id: 'div5',
  },
];

function GeneralRules() {
  const GenList = GeneralList.map((targetDivs, divId) => (
    <SouthProp key={targetDivs.id} targetDivs={targetDivs} divId={divId} />
  ));

  return (
    <div className="container row">
      {/* <BuildBootStrapMenu /> */}
      <div>
        <Typography
          variant="h6"
          sx={{
            marginBottom: '20px',
            textAlign: 'center',
            backgroundColor: 'lightgray',
          }}
        >
          <span>
            You opened a parking account? Here is what you need to know.
          </span>
          <br />
          <span>General policies that apply to all campuses.</span>
        </Typography>

        <div
          style={{
            marginBottom: 25,
            backgroundColor: '#F2FFFF',
            padding: 15,
          }}
        >
          <p style={{ marginBottom: -2, fontSize: '14px' }}>
            <HashLink smooth to="#loa">
              {' '}
              When I return from LOA, do I resume my parking at the same parking
              facility that I used before my LOA began?
            </HashLink>
          </p>
          <p style={{ marginBottom: -2, fontSize: '14px' }}>
            <HashLink smooth to="#prorate">
              {' '}
              Is there a prorate amount that I must pay when I open an account?
            </HashLink>
          </p>
          <p style={{ marginBottom: -2, fontSize: '14px' }}>
            <HashLink smooth to="#payment">
              How do I pay my parking fee each month?
            </HashLink>
          </p>
          <p style={{ marginBottom: -2, fontSize: '14px' }}>
            <HashLink smooth to="#cancel">
              Can I cancel my account?
            </HashLink>
          </p>
          <p style={{ marginBottom: -2, fontSize: '14px' }}>
            <HashLink smooth to="#suspend">
              Can I suspend my account?
            </HashLink>
          </p>
          <p style={{ marginBottom: -2, fontSize: '14px' }}>
            <HashLink smooth to="#dual-access">
              If I park at one campus, do I have access to other campuses’
              parking?
            </HashLink>
          </p>
          <p style={{ marginBottom: -2, fontSize: '14px' }}>
            <HashLink smooth to="#access-cards">
              Is my access card or RFID tag transferrable?
            </HashLink>
          </p>
          <p style={{ marginBottom: -2, fontSize: '14px' }}>
            <HashLink smooth to="#card-charge">
              Is there a charge for RFID tags or access cards?
            </HashLink>
          </p>
          <p style={{ marginBottom: -2, fontSize: '14px' }}>
            <HashLink smooth to="#card-charge">
              If my position change requires monthly rate change, when does my
              new rate take effect?
            </HashLink>
          </p>
        </div>
        <div className="row">
          <p id="loa" style={{ marginBottom: 1 }}>
            <p
              style={{ marginBottom: -1, fontWeight: 'bold', fontSize: '18px' }}
            >
              <span>
                {<FontAwesomeIcon icon={faCircleQuestion} />} When I return from
                LOA, do I resume my parking at the same parking facility that I
                used before my LOA began?
              </span>
            </p>
            <p style={{ fontSize: '16px' }}>
              <span>
                Yes, employees who return from LOA are assigned to the same
                location where they parked before going on LOA. Furthermore,
                parking access and restrictions will remain unchanged. It is the
                employees' obligation to notify the parking staff when they
                begin and return from their leave. Refunds are provided only if
                the Parking Department is informed of the intended LOA and does
                not discontinue collecting parking payments in time.
                <span>
                  {' '}
                  Please click{' '}
                  <a href="https://app.smartsheet.com/b/form/3e25fe741ade4a9587749f1c9c87cdae">
                    here
                  </a>{' '}
                  to access the online cancellation form.
                </span>
              </span>
            </p>
          </p>
          <p style={{ marginBottom: -1 }} id="prorate">
            <p
              style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: -1 }}
            >
              {<FontAwesomeIcon icon={faCircleQuestion} />} Is there a prorate
              amount that I must pay when I open an account?
            </p>
            <p style={{ fontSize: '16px' }}>
              {/* {<FontAwesomeIcon icon={faCircleInfo} />} */}
              Yes, a prorated amount must be paid upon opening an account. The
              amount due is shown on a rate breakdown sheet that the parking
              team must email to you. Prorate calculations differ based on
              whether the employee gets paid weekly or biweekly.
              <p>
                Click{' '}
                <Link to="/MonthlyProrateForm" style={{ fontWeight: 'bold' }}>
                  here
                </Link>{' '}
                to calculate the prorate amount.
              </p>
            </p>
          </p>
          <p style={{ marginBottom: 1 }} id="payment">
            <p
              style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: -1 }}
            >
              {<FontAwesomeIcon icon={faCircleQuestion} />} How do I pay my
              parking fee each month?
            </p>
            <p style={{ fontSize: '16px' }}>
              {/* {<FontAwesomeIcon icon={faCircleInfo} />} */}
              It is recommended that all employees participate in the NYP
              payroll deduction program. An employee can request that he or she
              be billed each month. Employees who prefer to be billed must pay
              their parking fee before the fifth business day of each month.
            </p>
          </p>
          <p style={{ marginBottom: 1 }} id="cancel">
            <p
              style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: -1 }}
            >
              {<FontAwesomeIcon icon={faCircleQuestion} />} Can I cancel my
              account?
            </p>
            <p style={{ fontSize: '16px' }}>
              Employees have the option to cancel their accounts at any time.
              The cancellation will be effective on the 15th or at the end of
              the month. Parking for a minimum of one day between the 1st and
              15th, or from the 16th to the end of the month, will result in a
              charge for a complete period. When employees cancel their accounts
              and later return, provided they were not on LOA, they must reapply
              for parking. They may be placed on a waiting list or assigned to a
              different location than the one they used prior to canceling the
              account. It is the employees' obligation to notify the parking
              staff about the accounts cancellation. Refunds are provided only
              if the Parking Department is informed of the intended account
              cancellation and does not discontinue collecting parking payments
              in time.
              <span>
                {' '}
                Please click{' '}
                <a href="https://app.smartsheet.com/b/form/3e25fe741ade4a9587749f1c9c87cdae">
                  here
                </a>{' '}
                to access the online cancellation form.
              </span>
            </p>
          </p>
          <p style={{ marginBottom: 1 }} id="suspend">
            <p
              style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: -1 }}
            >
              {<FontAwesomeIcon icon={faCircleQuestion} />} Can I suspend my
              account?
            </p>
            <p style={{ fontSize: '16px' }}>
              Accounts can only be suspended for employees who are on LOA.
              Parking Office may request paperwork to confirm whether an LOA has
              been authorized. It is the employees' obligation to notify the
              parking staff when they begin and return from their leave. Refunds
              are provided only if the Parking Department is informed of the
              intended LOA and does not discontinue collecting parking payments
              in time.
              <span>
                {' '}
                Please click{' '}
                <a href="https://app.smartsheet.com/b/form/3e25fe741ade4a9587749f1c9c87cdae">
                  here
                </a>{' '}
                to access the online cancellation form.
              </span>
            </p>
            {/* {<FontAwesomeIcon icon={faCircleInfo} />}  */}
          </p>
          <p style={{ marginBottom: 1 }} id="dual-access">
            <p
              style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: -1 }}
            >
              {<FontAwesomeIcon icon={faCircleQuestion} />} If I park at one
              campus, do I have access to other campuses’ parking?
            </p>

            <p style={{ fontSize: '16px' }}>
              {/* {<FontAwesomeIcon icon={faCircleInfo} />}  */}
              No. Because of waiting lists, we do not grant access to other
              campuses. Your access is limited to the Campus and location to
              which you have been assigned.
            </p>
          </p>
          <p style={{ marginBottom: 1 }} id="access-cards">
            <p
              style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: -1 }}
            >
              {<FontAwesomeIcon icon={faCircleQuestion} />} Is my access card or
              RFID tag transferrable?
            </p>

            <p style={{ fontSize: '16px' }}>
              {' '}
              {/* {<FontAwesomeIcon icon={faCircleInfo} />} */}
              No, Parking Department follow "One Employee One Account" policy.
              Access cards can only be used by the employee whose name is on the
              monthly account.
            </p>
          </p>
          <p style={{ marginBottom: -1 }} id="card-charge">
            <p
              style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: -1 }}
            >
              {<FontAwesomeIcon icon={faCircleQuestion} />} Is there a charge
              for RFID tags or access cards?
            </p>

            <p style={{ fontSize: '16px' }}>
              {/* {<FontAwesomeIcon icon={faCircleInfo} />}  */}
              Yes, there is a charge for new, damaged or lost RFID tag or access
              card. Please contact the parking office immediately when the RFID
              tag is damaged or access card is lost.
            </p>
          </p>
          <p style={{ marginBottom: -1 }} id="card-charge">
            <p
              style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: -1 }}
            >
              {<FontAwesomeIcon icon={faCircleQuestion} />} If my position
              change requires monthly rate change, when does my new rate take
              effect?
            </p>

            <p style={{ fontSize: '16px' }}>
              {/* {<FontAwesomeIcon icon={faCircleInfo} />}  */}
              If you begin the month with a specific monthly rate, that rate
              will remain in effect through the end of the month. When
              transitioning to a position that involves a change in monthly
              rate, the new rate will take effect on the first day of the
              following month. In other words, even if the position change
              occurs mid-month, the current rate will continue until the end of
              the month, and the updated rate will apply starting on the first
              of the next month.
            </p>
          </p>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
}
export default GeneralRules;
